<template>
  <div>
    <div class="content" v-if="isList">
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 订单号 -->
          <li> {{ $t('message.orderNumber') }}</li>
          <!-- 番数 -->
          <li> {{ $t('message.numberOfWords') }}</li>
          <!-- 问题产品番数 -->
          <li> {{ $t('message.numberOfProblematicProductOrders') }}</li>
          <!-- 订单状态 -->
          <li> {{ $t('message.orderStatus') }}</li>
          <!-- 客户入金时间 -->
          <li> {{ $t('message.customerDepositTime') }}</li>
          <!-- 预计上架时间 -->
          <li> {{ $t('message.expectedShelfLife') }}</li>
          <!-- 详细 -->
          <li class="flex05"> {{ $t('message.detail') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">{{ item.rowNumber }}</li>
          <!-- 订单号 -->
          <li>
            <router-link :to="'/orderDetail?order_sn=' + item.order_sn" class="a-link" target="_blank">
              {{ item.order_sn }}
            </router-link>
          </li>
          <!-- 番数 -->
          <li> {{ item.sorting_count }}</li>
          <!-- 问题产品番数 -->
          <li> {{ item.problem_count }}</li>
          <!-- 订单状态 -->
          <li> {{ item.status }}</li>
          <!-- 客户入金时间 -->
          <li> {{ item.datetime_pay_submit }}</li>
          <!-- 预计上架时间 -->
          <li> {{ item.datetime_up_complete }}</li>
          <!-- 详细 -->
          <li class="flex05">
            <el-button type="text" @click="look(item.order_sn)">
              {{ $t('message.look') }}
            </el-button>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 详情 -->
    <div class="detail" v-else>
      <!-- 订单号 -->
      <div class="order">
        {{ $t('message.orderNumber') }} : {{ detailData.order_sn }}
        <el-button type="text" class="fr" @click="isList = !isList">
          << 返回</el-button>
      </div>
      <div class="orderDetai">
        <!-- 订单状态 -->
        <div class="item">
          <div class="label">
            {{ $t('message.orderStatus') }}
          </div>
          <div class="value">
            {{ detailData.order_status }}
          </div>
        </div>
        <!-- 退款金额 -->
        <div class="item">
          <div class="label">
            {{ $t('message.refundAmount') }}
          </div>
          <div class="value">
            {{ detailData.indemnity_amount }}
          </div>
        </div>
      </div>
      <!-- 详细 -->
      <div class="details">
        <h3>{{ $t('message.detail') }}</h3>
      </div>
      <div class="table">
        <ol>
          <!-- 番号 -->
          <li class="flex05">{{ $t('message.mash') }}</li>
          <!-- 旺旺 -->
          <li> {{ $t('message.wangwang') }}</li>
          <!-- 写真 -->
          <li> {{ $t('message.photo') }}</li>
          <!-- 商品属性 -->
          <li> {{ $t('message.commodityAttribute') }}</li>
          <!-- 问题产品数 -->
          <li> {{ $t('message.numberOfProblemProducts') }}</li>
          <!-- 价格 -->
          <li> {{ $t('message.price') }}</li>
          <!-- 提出人 -->
          <li> {{ $t('message.peoplePutForward') }}</li>
          <!-- 问题描述 -->
          <li> {{ $t('message.problemDescriptionMS') }}</li>
          <!-- 问题图片 -->
          <li> {{ $t('message.problemPic') }}</li>
          <!-- 问题状态 -->
          <li> {{ $t('message.problemState') }}</li>
          <!-- 运费 -->
          <li> {{ $t('message.freight') }}</li>
          <!-- option -->
          <li> option</li>
        </ol>
        <ul v-for="(item, index) in detailData.data" :key="index">
          <!-- 番号 -->
          <li class="flex05">{{ item.sorting }}</li>
          <!-- 旺旺 -->
          <li> {{ item.shop_name }}</li>
          <!-- 写真 -->
          <li>
            <el-image style="width: 60px; height: 60px" :src="item.pic" :preview-src-list="[item.pic]">
            </el-image>

          </li>
          <!-- 商品属性 -->
          <li>
            <div>
              <p v-for="(items) in item.detail">
                {{ items.key }}:{{ items.value }}
              </p>
            </div>
          </li>
          <!-- 问题产品数 -->
          <li>
            <div>
              <p>问题：{{ item.problem_num }}</p>
              <p>可能：{{ item.confirm_num }}</p>
              <p>购买数：{{ item.purchase_num }}</p>
            </div>
          </li>
          <!-- 价格 -->
          <li>
            <div>
              <p>买时：{{ item.goods_price }}</p>
              <p>确认：{{ item.pre_price }}</p>
            </div>
          </li>
          <!-- 提出人 -->
          <li> {{ item.created_by }}</li>
          <!-- 问题描述 -->
          <li> {{ item.description }}</li>
          <!-- 问题图片 -->
          <li>
            <div>
              <el-image style="width: 60px; height: 60px; margin:0px 5px 5px 0  ;" :src="items.image"
                :preview-src-list="[items.image]" v-for="(items, indexs) in item.problem_img" :key="indexs">
              </el-image>
            </div>
          </li>
          <!-- 问题状态 -->
          <li> {{ item.status }}</li>
          <!-- 运费 -->
          <li> {{ item.confirm_freight }}</li>
          <!-- option -->
          <li> {{ item.option_amount }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      datas: {
        page: 1,
        pageSize: 10,
        user_id: this.$route.query.userID,
      },
      total: 0,
      isList: true,
      detailData: {},

    };
  },
  created() {
    this.problemProductList()
  },
  methods: {
    problemProductList() {
      this.$api.clienteleApi.problemProductList(this.datas).then((res) => {
        this.tableData = res.data.data
        this.total = res.data.total
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.problemProductList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.problemProductList();
    },
    // 查看
    look(order_sn) {
      this.$api.clienteleApi.problemProductDetail({ order_sn }).then((res) => {
        this.detailData = res.data
        this.detailData.order_sn = order_sn
        this.isList = false
      });

    },
  }
}
</script>
<style lang='scss' scoped>
.table {
  .flex05 {
    flex: 0.5;
  }
}

.detail {
  .order {
    font-size: 18px;
    font-weight: 600;
    line-height: 40px;
  }

  .orderDetai {
    display: flex;
    margin: 24px 0;

    .item {
      border: 1px solid #ccc;

      &:nth-last-child(1) {
        border-left: 0;
      }

      .label {
        padding: 12px 24px;
        text-align: center;
        border-bottom: 1px solid #ccc;
      }

      .value {
        padding: 12px 24px;
        text-align: center;
      }
    }
  }

  .details {
    h3 {
      font-size: 18px;
      font-weight: 600;
      margin: 24px 0;
    }
  }
}
</style>